import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { Authenticationservice } from '../services/authentication.service';
import { AuthService } from '../services/auth.service';
import { KeycloakProfile } from 'keycloak-js';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
})
export class CallbackComponent {
  encryptInfo;
  username_n: string;
  currentPath: string | null = null;
  constructor(private router: Router
    , private auth_brd: Authenticationservice
    , private authService: AuthService) {
    let user: any = this.auth_brd.Authention();
    console.log('loadUserProfileBRD:', user);
    this.username_n = user.username_n
  }
  data_sso?: KeycloakProfile;

  async ngOnInit() {
    let username_n = this.username_n;
    let dataSso = this.data_sso = await this.authService.loadUserProfile();
    console.log("username_n", username_n)
    console.log('loadUserProfileSSO:', dataSso);

    if (!username_n) this.OnCheckIn();
    else if (username_n.trim().toLowerCase() != dataSso.username.trim().toLowerCase()) this.OnCheckIn()
    else this.goBack();
    //this.OnCheckIn()
  }

  OnLogout() {
    this.authService.logout();
  }

  OnCheckIn() {
    console.log("OnCheckIn")
    let dataS = this.data_sso;
    let username: string = '011', password: string = '8888';
    //console.log('password:', this.hashPassword(password));
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/function-2/select_sfw?s=*&f=[dbCPS].[dbo].[get_user_v3]('${dataS.username}')&w=1=1`;
    //let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/get_users_ss?user=${username}&pass=${this.hashPassword(password)}`;
    fetch(url)
      .then(res => res.json())
      .then((out: any) => {
        if (out.length > 0) {
          const data = out;
          let endata = { username: data.supname, code: data.supcode, username_n: dataS.username, alldata: data }
          this.encryptInfo = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(endata), 'bsfdev').toString());
          localStorage.setItem('userdata', this.encryptInfo);
          // console.log('data in login :' ,this.data.alldata)
          localStorage.setItem('supcode', data[0].supcode);
          localStorage.setItem('supzone', data[0].zonedata);
          localStorage.setItem('yearTh', '6667');
          localStorage.setItem('yearCr', '2324');
          //console.log('data: ', data[0])

          let ulvl = data[0].userlevel;
          /*if (ulvl == '5' || ulvl == '6' || ulvl == '7' || ulvl == '9' || ulvl == '10') {
            this.router.navigateByUrl("/finance");
          }
          else {
            this.router.navigateByUrl("/dashboardkpi");
          }*/
          this.goBack();
        }
        else { alert(`_!!!! ไม่พบ user: ${dataS.username} !!!_`); }
      }).catch(err => { throw err });
  }
  goBack() {
    let route = localStorage.getItem('route');
    console.log("route", route)
    console.log(!route)
    if (true) {
      console.log("change route")
      route = '/dashboardkpi'
    }
    console.log('localStorage.route:', route);
    this.router.navigate([route])
      .then((e) => {
        console.log("ON navigate success", e)
      })
      .catch((e) => {
        console.log("On navigate error", e)
      })
  }
}
